import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import * as _ from 'lodash';

import {
  FiltersService
} from '../../services';

@Component({
  selector: 'app-regions-states',
  templateUrl: './regions-states.component.html',
  styleUrls: ['./regions-states.component.scss']
})
export class RegionsStatesComponent implements OnInit {
  @Output() regions = new EventEmitter();
  @Output() states = new EventEmitter();

  @Input() selectedRegions = [];
  @Input() selectedStates = [];

  @ViewChild('autocompleteRegions', { static: true }) autocompleteRegions;
  @ViewChild('autocompleteStates', { static: true }) autocompleteStates;

  autocompleteDataRegions;
  autocompleteDataStates;

  placeHolder = "Pesquisar";
  notFoundText = "Sem resultados";

  searchKeywordRegion = "dsRegiao";
  searchKeywordState = "dsEstado";

  constructor( private filtersService: FiltersService ) { }

  ngOnInit() {
    this.listRegionsStates();
  }

  listRegionsStates() {
    this.autocompleteDataRegions = [];
    this.autocompleteDataStates = [];

    this.filtersService.listRegionsStates().subscribe((response) => {
      for (let i = 0; i < response['data'].length; i++) {
        this.autocompleteDataRegions.push({
          cdRegiao: response['data'][i].cdRegiao,
          dsRegiao: response['data'][i].dsRegiao
        });

        for (let ii = 0; ii < response['data'][i].estados.length; ii++) {
          this.autocompleteDataStates.push({
            sgEstado: response['data'][i].estados[ii].sgEstado,
            dsRegiao: response['data'][i].dsRegiao,
            dsEstado: response['data'][i].estados[ii].dsEstado
          });
        }
      }

      this.autocompleteDataRegions = _.orderBy(this.autocompleteDataRegions, 'dsRegiao');

      this.autocompleteDataStates = _.orderBy(this.autocompleteDataStates, 'dsEstado');
    });
  }

  onSelectRegions(item, group?) {
    this.selectedRegions.push(item);

    this.selectedRegions = _.uniqBy(this.selectedRegions, 'dsRegiao');

    this.autocompleteRegions.query = "";

    if (group) {
      let filter = _.filter(this.autocompleteDataStates, { 'dsRegiao': item.dsRegiao });

      for (let i = 0; i < filter.length; i++) {
        this.onSelectStates(filter[i])
      }
    }

    this.regions.emit(this.selectedRegions);
  }

  onSelectStates(item, group?) {
    this.selectedStates.push(item);

    this.selectedStates = _.uniqBy(this.selectedStates, 'dsEstado');

    this.autocompleteStates.query = "";

    if (group) {
      let filter = _.filter(this.autocompleteDataRegions, { 'dsRegiao': item.dsRegiao });

      for (let i = 0; i < filter.length; i++) {
        this.onSelectRegions(filter[i])
      }
    }

    this.states.emit(this.selectedStates);
  }

  deleteSelectRegions(item) {
    _.remove(this.selectedRegions, function(n) {
      return n.dsRegiao == item.dsRegiao;
    });

    _.remove(this.selectedStates, function(n) {
      return n.dsRegiao == item.dsRegiao;
    });
  }

  deleteSelectStates(item) {
    _.remove(this.selectedStates, function(n) {
      return n.dsEstado == item.dsEstado;
    });

    let count = _.filter(this.selectedStates, { 'dsRegiao': item.dsRegiao }).length;

    if (count == 0) {
      _.remove(this.selectedRegions, function(n) {
        return n.dsRegiao == item.dsRegiao;
      });
    }
  }

}
